document.addEventListener("DOMContentLoaded", () => {
  setTimeout(function(){
    document.querySelectorAll('.product-color-swatches').forEach(swatches => {
      swatches.querySelectorAll('.color-swatch').forEach(swatch => {
        let pos1 = swatch.getAttribute('data-pos-1');
        let pos2 = swatch.getAttribute('data-pos-2');
    
        if (pos2 > 1) {
          const baseSwatch = swatches.querySelector(`.color-swatch[data-pos-1="${pos1}"][data-pos-2="1"]`);
          if (baseSwatch) {
            let styleValue = baseSwatch.getAttribute('style');
            let classValue = baseSwatch.getAttribute('class');
            swatch.setAttribute('style', styleValue);
            swatch.setAttribute('class', classValue);
          } else {
            console.warn(`No base swatch found for pos1=${pos1}, pos2=1`);
          }
        }
      });
    });
  }, 2000);

  document.body.addEventListener("click", (e) => {
      let swatch = e.target.closest(".product-color-swatches .color-swatch");
      if (!swatch) return;

      let optionID = swatch.previousElementSibling?.value;
      let pos1 = swatch.getAttribute('data-pos-1');
      let pos2 = swatch.getAttribute('data-pos-2');
      // let color = swatch.textContent.trim();
      let color = swatch.closest(".product-color-swatches").querySelector(`.color-swatch[data-pos-1="${pos1}"][data-pos-2="1"]`).textContent.trim();
      let variantList = swatch.closest(".product-color-swatches").querySelectorAll(`.color-swatch-list[data-color="${color}"]`)[pos2-1];
      let variantID = variantList ? variantList.getAttribute("data-id") : null;

      console.log("c", color, variantID);
      const modal = swatch.closest(".horizontal-product-card__info").querySelector('.quick-buy-modal');
      if (modal) {
          const modalID = modal.getAttribute('id');
          const handle = modal.getAttribute('handle').split('?variant=')[0] + '?variant=' + variantID;
      
          document.querySelectorAll(`.quick-buy-modal[id="${modalID}"]`).forEach(modal_ele => {
              modal_ele.setAttribute('handle', handle);
          });
      } else {
          console.warn('Modal not found for swatch:', swatch);
      }
    
      let productCard = swatch.closest(".horizontal-product-card");
      if (productCard) {
          let inputField = productCard.querySelector('input[name="id"]');
          if (inputField) {
              inputField.value = variantID;
          }
      }
  });
  
  document.body.addEventListener("click", (e) => {
    let main_ATC = e.target.closest('.product [data-block-id="buy_buttons"] button[type="submit"]');
    if(main_ATC) {
      document.documentElement.addEventListener("theme:loading:end", () => {
        console.log("Theme loading has ended!");
        window.location.href = `${Shopify.routes.root}cart`;
      });      
    }
  });

});